import React from "react";
import CustomDialog from "../Utils/Dialogs/CustomDialog";
import Form from "react-bootstrap/Form";
import Label from "../Utils/FormInputs/Label";
import {CustomInput} from "../Inventory/CustomInput";
import axios from "axios";
import {config} from "../../Helpers/env";
import {errorMessages} from "../../Helpers/ErrorMessages";
import {dateConvert} from "../Utils/ConvertDate";

export function AddExchangeRate({openDialog, setOpenDialog, isSubmitted, setIsSubmitted, actions, currencyDetails}) {
    const [submitted, setSubmitted] = React.useState(false)
    const formRef = React.useRef()


    const handleSubmit = (event) => {
        event.preventDefault()
        setSubmitted(true)
        const form = new FormData(event.currentTarget)
        const fieldValues = Object.fromEntries(form.entries())
        const ex_rate = fieldValues?.exchange_rate ? Math.pow(Number(fieldValues?.exchange_rate), -1) : 1;
        if (fieldValues.date_as_of && fieldValues?.exchange_rate) {
            setIsSubmitted('pending')
            axios.post(`${config.smsUrl}/currency/add_exchange_rate`, {
                currency_id: Number(currencyDetails.currency_id),
                date_as_of: fieldValues.date_as_of,
                exchange_rate: ex_rate
            }).then(() => {
                actions.snackbarActions.snackSuccess('Exchange rate added successfully');
                setIsSubmitted('resolved');
                setSubmitted(false);
                setOpenDialog(false);
            }).catch(err => {
                errorMessages(err, null, actions);
                setIsSubmitted('rejected');
            });
        }
    }


    const isPending = isSubmitted === 'pending'

    const current_date = dateConvert()

    return (
        <CustomDialog handleClose={() => {
            setOpenDialog(false)
        }} open={openDialog} title="Add Exchange Rate"
                      buttons={null}>
            <form ref={formRef} autoComplete='off' onSubmit={handleSubmit}>
                <Form.Group>
                    <Label name='Currency' htmlFor="currency" type/>
                    <CustomInput submitted={submitted} name='currency' type='text'
                                 inputValue={`${currencyDetails.currency_symbol} ${currencyDetails.currency_name}`}
                                 disabled/>
                </Form.Group>
                <Form.Group>
                    <Label name="As of date" htmlFor="date_as_of" type/>
                    <CustomInput submitted={submitted} name='date_as_of' type='date'
                                 isRequired min={current_date} max={current_date}/>
                </Form.Group>
                <Form.Group>
                    <Label name="Exchange rate" htmlFor="exchange_rate" type/>
                    <CustomInput submitted={submitted} name='exchange_rate' type='number'
                                 isRequired/>
                </Form.Group>
                <button type='submit' disabled={isPending}
                        className='btn btn-sm sms-info-btn small-btn'>{isPending ? 'Saving...' : 'Save'}</button>
            </form>
        </CustomDialog>
    )
}